import React from 'react';
// import { Link } from 'react-router-dom';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { useState, useEffect } from 'react';
import {
  AddCarSaleListing,
  AddBannerMedia,
  AddMedia,
} from './../../../../Redux/Actions/UserAction';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

const images = [
  {
    original: 'assets/images/user/car-dealers/a.jpg',
    thumbnail: 'assets/images/user/car-dealers/a.jpg',
  },
  {
    original: 'assets/images/user/car-dealers/b.jpg',
    thumbnail: 'assets/images/user/car-dealers/b.jpg',
  },
  {
    original: 'assets/images/user/car-dealers/c.jpg',
    thumbnail: 'assets/images/user/car-dealers/c.jpg',
  },
  {
    original: 'assets/images/user/car-dealers/d.jpg',
    thumbnail: 'assets/images/user/car-dealers/d.jpg',
  },
];

export default function CarForSalePost(props) {
  const home = useSelector((state) => state?.home);
  const mediaId = home?.AddMediaList?.data?.response?.media;
  // const { state } = useParams();
  // const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const { state, files, imageblob } = props.location;

  // if (state === undefined && imageblob === undefined) {
  // 	console.log('this is the use hstory');
  // 	history.goBack();
  // }

  console.log('this is the cardata', state);
  console.log('this is the mediaid', mediaId);

  const [CarSaleData, setCarSaleData] = useState({});

  useEffect(() => {
    setCarSaleData(state);
    if (state === undefined && imageblob === undefined) {
      window.location.href = '#/sp-cars-for-sale';
      // history.goBack();
    }
  }, [state]);

  useEffect(() => {
    if (mediaId !== undefined) {
      var CarImageId = mediaId?.map((item) => {
        return item.mediaId;
      });
      setCarSaleData({
        ...CarSaleData,
        mediaIds: {
          ...CarSaleData.mediaIds,
          CAR_IMAGE: CarImageId,
        },
      });
    }

    console.log('this is the carimage id ', CarImageId);
    console.log('this is the carsaleData', CarSaleData);
  }, [mediaId]);

  useEffect(() => {
    if (
      files !== undefined &&
      mediaId !== undefined &&
      state?.CAR_IMAGE?.length !== 0
    ) {
      dispatch(AddCarSaleListing(CarSaleData));
    }
  }, []);

  const PostData = () => {
    const formData = new FormData();
    console.log('this is the props', CarSaleData, files, imageblob);
    if (files !== undefined && files?.length !== 0 && files !== null) {
      files.map((item) => {
        formData.append('media', item);
      });
      dispatch(AddBannerMedia({ formData }));
      console.log('this is the props', CarSaleData, files, imageblob);
    } else {
      Swal.fire({
        title: 'Car Image Require!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
    }
  };

  // console.log('this is the props', CarSaleData, file, imageblob);
  return (
    <div>
      <div class="main-content-area">
        <div class="container">
          <p class="mb-5 text-center">
            <button
              class="btn btn-warning btn-lg"
              // href='#'
              // role='button'
              onClick={PostData}
            >
              <i class="fas fa-paper-plane"></i> POST
            </button>
          </p>

          <div class="row mb-5">
            <div class="col-12 col-sm-12 col-md-7 col-lg-7 mb-2 mb-sm-2 mb-md-2 mb-lg-0">
              <div class="bxslider">
                <ImageGallery
                  items={
                    imageblob !== undefined
                      ? imageblob?.map((item) => {
                          return {
                            original: item,
                            thumbnail: item,
                            originalHeight: '360',
                            originalWidth: '500',
                            sizes: '700',
                          };
                        })
                      : []
                  }
                  class="img-fluid"
                />
                {/* <div><img src="assets/images/user/car-dealers/a.jpg" alt="" class="img-fluid" /></div>
                                <div><img src="assets/images/user/car-dealers/b.jpg" alt="" class="img-fluid" /></div>
                                <div><img src="assets/images/user/car-dealers/c.jpg" alt="" class="img-fluid" /></div>
                                <div><img src="assets/images/user/car-dealers/d.jpg" alt="" class="img-fluid" /></div> */}
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-5 col-lg-5 d-flex align-items-end">
              <div class="w-100">
                <p>
                  <small>
                    <i class="far fa-calendar-alt"></i> Posted Yesterday
                  </small>
                </p>

                <h3 class="mb-0">{state?.carBrand} </h3>
                <p>{state?.carModel}</p>

                <p>{state?.description}</p>

                <div class="car-details-block">
                  <div class="row">
                    <div class="col-12">
                      <div class="car-details-block-horizontal">
                        <div class="row">
                          <div class="col-3">
                            <div class="line-a">Year</div>
                            <div class="line-b">{state?.modelYear}</div>
                          </div>
                          <div class="col-3">
                            <div class="line-a">Color</div>
                            <div class="line-b">Black</div>
                          </div>
                          <div class="col-3">
                            <div class="line-a">Km</div>
                            <div class="line-b">{state?.kilometerDriven}</div>
                          </div>
                          <div class="col-3">
                            <div class="line-a">Cyllnder</div>
                            <div class="line-b">{state?.cyclinder}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="car-agent-cwm">
                  <div class="row">
                    <div class="col-4">
                      <a
                        class="btn btn-outline-secondary btn-block"
                        href="#"
                        role="button"
                      >
                        <img
                          src="assets/images/icons/user/car-dealers/telephone.svg"
                          alt=""
                          class="icon-cwm"
                        />{' '}
                        Call
                      </a>
                    </div>

                    <div class="col-4">
                      <a
                        class="btn btn-outline-secondary btn-block"
                        href="#"
                        role="button"
                      >
                        <img
                          src="assets/images/icons/user/car-dealers/whatsapp.svg"
                          alt=""
                          class="icon-cwm"
                        />{' '}
                        Whatsapp
                      </a>
                    </div>

                    <div class="col-4">
                      <a
                        class="btn btn-outline-secondary btn-block"
                        href="#"
                        role="button"
                      >
                        <img
                          src="assets/images/icons/user/car-dealers/map.svg"
                          alt=""
                          class="icon-cwm"
                        />{' '}
                        5 KM
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h3>Description</h3>
          <p>{state?.description}</p>

          <h3>Specifications</h3>

          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <td scope="col">Interior Color</td>
                <td scope="col">{state?.interiorColor}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td scope="row">Seats</td>
                <td>{state?.seats}</td>
              </tr>
              <tr>
                <td scope="row">Seat Material</td>
                <td>Leather</td>
              </tr>
              <tr>
                <td scope="row">AC Condition</td>
                <td>Good</td>
              </tr>
              <tr>
                <td scope="row">Max. Power</td>
                <td>640 CV @ 8.000 rpm</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
